import {styled} from "@mui/system";

export const CustomBox = styled("div")({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "5px",
});

export const CustomKeyTypography = styled("span")({
    fontSize: "12px",
    fontWeight: "bold",
});

export const CustomValueTypography = styled("span")({
    fontSize: "14px",
});